import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect (): void {
    this.addSelectedColumnsInputs()
  }

  private addSelectedColumnsInputs (): void {
    const urlParams = new URLSearchParams(window.location.search)
    const selectedColumns = urlParams.getAll('sc[]')

    if (selectedColumns.length > 0) {
      selectedColumns.forEach((column: string) => {
        this.element.appendChild(this.buildInput('sc[]', column))
      })
    }
  }

  private buildInput (name: string, value: string): HTMLInputElement {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    return input
  }
}
